import { useState, useMemo, useEffect } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as halfileActions from '@actions/halfile'
import Pagination from '@components/shared/Pagination'
import SearchInput from '@components/shared/SearchInput'

import './Collections.css'
import CircleSpinner from '@components/shared/CircleSpinner'
import CollectionsTabSelector from './CollectionsTabSelector'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { formatDate } from '@/utils/date'

const ITEMS_PER_PAGE = 20

export const HalfileCounties = () => {
    
    const [loading, setLoading] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const [query, setQuery] = useState('')
    
    const counties = useWireValue(store.counties)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    const fetchCounties = async () => {
        
        if (!remoteConfig?.halfile?.enabled) return
        
        setLoading(true)
        
        try {
            
            await halfileActions.fetchCounties()
            
        } catch (e) {
            
            toast.error('CountyRecords.com collections search is unavailable.')
            
        }
        
        setLoading(false)
        
    }
    
    const filteredCounties = useMemo(() => {
        
        if (!query?.length) return counties.slice(pageIndex * ITEMS_PER_PAGE, (pageIndex + 1) * ITEMS_PER_PAGE)
        
        return counties
            .filter(it => it.name.toLowerCase().includes(query))
            .slice(pageIndex * ITEMS_PER_PAGE, (pageIndex + 1) * ITEMS_PER_PAGE)
        
    }, [query, counties, pageIndex])
    
    useEffect(() => {
        setPageIndex(0)
    }, [query])
    
    useEffect(() => {
        fetchCounties()
    }, [])
    
    if (!remoteConfig?.halfile?.enabled)
        return null
    
    return (
        
        <div className="Collections">
            
            <div className="flex justify-between items-center content-center gap-4">
                
                <CollectionsTabSelector activeTab="halfile" />
                
                <div className="collections-search-container mb-4 grow">
                    
                    {/**** SEARCH ****/}
                    <div className="flex items-center content-center justify-between w-full gap-2">
                        
                        <SearchInput
                            className="w-full grow"
                            value={query}
                            placeholder="Search collections..."
                            onChange={e => setQuery(e.target.value.toLowerCase())}/>
                    
                    </div>
                
                </div>
            
            </div>
            
            <>
                {loading ? (
                    <div>
                        <CircleSpinner className="absolute-centered"/>
                    </div>
                ) : (
                    <div
                        className="table-responsive collections-list-viewport ml-0 pt-0 pl-0 pr-0">
                        <table className="table table-nowrap card-table table-pin-rows">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th className="md:table-cell">Documents</th>
                                    <th className="hidden md:table-cell">From</th>
                                    <th className="hidden md:table-cell">Thru</th>
                                </tr>
                            </thead>
                            <tbody className="list">
                                {filteredCounties.map(county =>
                                    <tr key={county.id}>
                                        <td>
                                            <Link to={county.id}>{county.name}</Link></td>
                                        <td>{county.documentCount}</td>
                                        <td>{formatDate(county.coverageStartDate, 'MM/DD/YYYY')}</td>
                                        <td>{formatDate(county.coverageEndDate, 'MM/DD/YYYY')}</td>
                                    </tr>,
                                )}
                            </tbody>
                        </table>
                        
                        <div className="py-4 col-12">
                            <Pagination
                                className="flex justify-center w-full"
                                count={counties.length}
                                itemsPerPage={ITEMS_PER_PAGE}
                                setPageIndex={setPageIndex}
                                forcePage={pageIndex}/>
                        </div>
                    </div>
                )}
            </>
        
        </div>
        
    )
    
}
